@if (
  CompanyVendor &&
  BusinessComplianceSetting &&
  BusinessComplianceResults &&
  ClientRegisteredVendor
) {
  <form [formGroup]="ComplianceFindingForm" class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row row-padding-percent-bottom justify-content-between">
          <div class="col-4 d-flex flex-column justify-content-flex-end">
            @if (
              hasBusinessReportData && ClientRegisteredVendor.country === 'US'
            ) {
              <div class="row">
                <div class="col">
                  <button
                    class="btn btn-primary h-100"
                    (click)="downloadBusinessVerificationReport()"
                  >
                    Download report data
                  </button>
                </div>
              </div>
            }
            <ng-container>
              <div class="row pt-2">
                <div class="col">
                  <button
                    class="btn btn-primary h-100"
                    (click)="runBusinessVerification()"
                  >
                    Run public data
                  </button>
                </div>
              </div>
              @if (
                hasBusinessReportData &&
                ClientRegisteredVendor.country === 'US' &&
                LoggedInUser.UserAccountType?.name === 'Admin'
              ) {
                <div class="row pt-2">
                  <div class="col">
                    <button
                      class="btn btn-primary h-100"
                      (click)="downloadRawDataReports()"
                    >
                      Download raw data
                    </button>
                  </div>
                </div>
              }
              @if (hasActiveBusinessVerificationApiError()) {
                <div class="row pt-2">
                  <div class="col">
                    <button
                      class="btn btn-primary h-100"
                      (click)="clearBusinessVerificationErrors()"
                    >
                      Clear business verification errors
                    </button>
                  </div>
                </div>
              }
              @if (
                RequestJobs.length > 0 &&
                LoggedInUser.UserAccountType?.name === 'Admin'
              ) {
                <div class="row pt-2">
                  <div class="col">
                    <button
                      class="btn btn-primary h-100"
                      (click)="resetStuckVerification()"
                    >
                      Reset stuck verification
                    </button>
                  </div>
                </div>
              }
            </ng-container>
          </div>
          <div class="col">
            <div class="row">
              @if (CompanyVendor.isUsingNewBusinessVerification) {
                <div class="col">
                  <label
                    >Findings Last Updated:
                    {{
                      $safeNavigationMigration(
                        CompanyVendor.ClientRegisteredVendor?.ComplianceFinding
                          ?.v2BusinessVerificationUpdatedAt
                      ) | date: 'MM/dd/y'
                    }}</label
                  >
                </div>
              }
              @if (!CompanyVendor.isUsingNewBusinessVerification) {
                <div class="col">
                  <label
                    >Findings Last Updated:
                    {{
                      $safeNavigationMigration(
                        CompanyVendor.ClientRegisteredVendor?.ComplianceFinding
                          ?.legacyBusinessVerificationUpdatedAt
                      ) | date: 'MM/dd/y'
                    }}</label
                  >
                </div>
              }
            </div>
            <div class="row">
              <div class="col">
                <label
                  >Last Run Date:
                  {{
                    $safeNavigationMigration(
                      CompanyVendor.ClientRegisteredVendor
                        ?.lastRanBusinessVerificationReportDate
                    ) | date: 'MM/dd/y'
                  }}</label
                >
              </div>
            </div>
            @if (
              BusinessVerificationApiErrorLongestRetryTime &&
              !hasLexisNexisCorporateFilingError
            ) {
              <div class="row">
                <div class="col">
                  <label class="error-red"
                    >Business Verification API Error. Please check back in
                    {{ nextRunInHours }}</label
                  >
                </div>
              </div>
            }
            @if (hasLexisNexisCorporateFilingError) {
              <div class="row">
                <div class="col">
                  <label class="error-red"
                    >LexisNexis Corporate Filing Search failed. Please manually
                    verify data.</label
                  >
                </div>
              </div>
            }
            @if (isRunningBusinessVerification || RequestJobs.length > 0) {
              <div class="row">
                <div class="col">
                  <label class="error-red"
                    >Business Verification is running on this Vendor. Please
                    check back in a few minutes.</label
                  >
                </div>
              </div>
            }
          </div>
        </div>
        <div
          class="row justify-content-around align-items-center text-center border-bottom mb-3"
        >
          <div class="col-4">
            <label class="label">Company Background</label>
          </div>
          <div class="col-lg-3">
            <label class="label">Finding</label>
          </div>
          <div class="col">
            <label class="label">Requirement</label>
          </div>
          <div class="col">
            <label class="label">Result</label>
          </div>
        </div>
        @if (
          !checkIfNullOrUndefined(BusinessComplianceSetting.secretaryOfState) &&
          !isNotRequiredResult(
            BusinessComplianceResults.secretaryOfStateResults
          )
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">Secretary of State</label>
            </div>
            <div class="col-lg-3">
              <select
                class="form-select"
                formControlName="companySecretaryOfState"
              >
                @for (
                  secretaryOfStateObject of secretaryOfStateValues;
                  track secretaryOfStateObject
                ) {
                  <option [ngValue]="secretaryOfStateObject.value">
                    {{ secretaryOfStateObject.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceSetting.secretaryOfState
                  ? BusinessComplianceSetting.secretaryOfState
                  : 'No'
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.secretaryOfStateResults
              }}</label>
            </div>
          </div>
        }
        @if (
          !checkIfNullOrUndefined(BusinessComplianceSetting.businessVerified) &&
          !isNotRequiredResult(
            BusinessComplianceResults.businessVerifiedResults
          )
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">Business Name & Tax ID Verified</label>
            </div>
            <div class="col-lg-3">
              <select
                class="form-select"
                formControlName="companyBusinessVerified"
              >
                @for (yesNoObject of yesNoValues; track yesNoObject) {
                  <option [ngValue]="yesNoObject.value">
                    {{ yesNoObject.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceSetting.businessVerified ? 'Yes' : 'No'
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.businessVerifiedResults
              }}</label>
            </div>
          </div>
        }
        @if (
          !checkIfNullOrUndefined(
            BusinessComplianceSetting.governmentWatchlist
          ) &&
          !isNotRequiredResult(
            BusinessComplianceResults.governmentWatchlistResults
          )
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">Government Watchlist</label>
            </div>
            <div class="col-lg-3">
              <select
                class="form-select"
                formControlName="companyGovernmentWatchlist"
              >
                @for (
                  watchlistObject of watchlistValues;
                  track watchlistObject
                ) {
                  <option [ngValue]="watchlistObject.value">
                    {{ watchlistObject.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                getWatchlistRequirementLabel(
                  BusinessComplianceSetting.governmentWatchlist!
                )
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.governmentWatchlistResults
              }}</label>
            </div>
          </div>
        }
        @if (
          !checkIfNullOrUndefined(BusinessComplianceSetting.liens) &&
          !isNotRequiredResult(BusinessComplianceResults.lienResults)
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">Company Liens & Judgements</label>
            </div>
            <div class="col-lg-3">
              <input
                type="text"
                class="form-control"
                formControlName="companyLiensAndJudgments"
              />
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                getCorporateLiensLabel(BusinessComplianceSetting.liens!)
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.lienResults
              }}</label>
            </div>
          </div>
        }
        @if (
          !checkIfNullOrUndefined(BusinessComplianceSetting.bankruptcy) &&
          !isNotRequiredResult(BusinessComplianceResults.bankruptcyResults)
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">Company Bankruptcies</label>
            </div>
            <div class="col-lg-3">
              <select class="form-select" formControlName="companyBankruptcy">
                @for (
                  bankruptcyObject of bankruptcyValues;
                  track bankruptcyObject
                ) {
                  <option [ngValue]="bankruptcyObject.value">
                    {{ bankruptcyObject.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                getBankruptcyRequirementLabel(
                  BusinessComplianceSetting.bankruptcy!
                )
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.bankruptcyResults
              }}</label>
            </div>
          </div>
        }
        @if (
          !checkIfNullOrUndefined(BusinessComplianceSetting.address) &&
          !isNotRequiredResult(BusinessComplianceResults.addressResults)
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">Address</label>
            </div>
            <div class="col-lg-3">
              <select class="form-select" formControlName="companyAddress">
                @for (addressObject of addressValues; track addressObject) {
                  <option [ngValue]="addressObject.value">
                    {{ addressObject.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceSetting.address
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.addressResults
              }}</label>
            </div>
          </div>
        }
        @if (
          !checkIfNullOrUndefined(BusinessComplianceSetting.isW9Checked) &&
          !isNotRequiredResult(BusinessComplianceResults.w9Results)
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">W9 Accepted?</label>
            </div>
            <div class="col-lg-3">
              <select class="form-select" formControlName="companyW9Check">
                @for (yesNoObject of yesNoValues; track yesNoObject) {
                  <option [ngValue]="yesNoObject.value">
                    {{ yesNoObject.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceSetting.isW9Checked ? 'Yes' : 'No'
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.w9Results
              }}</label>
            </div>
          </div>
        }

        @if (
          !checkIfNullOrUndefined(BusinessComplianceSetting.requester) &&
          !isNotRequiredResult(BusinessComplianceResults.requesterResults)
        ) {
          <div
            class="row justify-content-around align-items-center text-center"
          >
            <div class="col-4">
              <label class="label">Requester Match?</label>
            </div>
            <div class="col-lg-3">
              <select class="form-select" formControlName="companyRequester">
                @for (
                  requesterObject of requesterValues;
                  track requesterObject
                ) {
                  <option [ngValue]="requesterObject.value">
                    {{ requesterObject.label }}
                  </option>
                }
              </select>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceSetting.requester ?? ''
              }}</label>
            </div>
            <div class="col">
              <label class="label" appStatusStyleChanges>{{
                BusinessComplianceResults.requesterResults
              }}</label>
            </div>
          </div>
        }

        @if (areFindingsOverrideable()) {
          <div class="row mt-3 justify-content-end">
            <div class="col-4">
              <button
                class="btn btn-primary h-100"
                (click)="overrideComplianceFindings()"
              >
                Override findings
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </form>
}
